import { render, staticRenderFns } from "./departmentList.vue?vue&type=template&id=5e2a12b8&scoped=true"
import script from "./departmentList.vue?vue&type=script&lang=ts"
export * from "./departmentList.vue?vue&type=script&lang=ts"
import style0 from "./departmentList.vue?vue&type=style&index=0&id=5e2a12b8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a12b8",
  null
  
)

export default component.exports